import React, { useContext, useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import useCurrentParticipantMember from './hooks/useCurrentParticipantMember';
import { ConversationSearchContext } from './providers/ConversationSearchProvider';

const InboxConversationItemVisibility = ({ conversation, children }) => {
    const [isVisible, setIsVisible] = useState(true);
    const { currentParticipantMember } = useCurrentParticipantMember(conversation);
    const { conversationSearchQuery, setConversationSearchQuery } = useContext(ConversationSearchContext);

    useEffect(() => {
        if (!currentParticipantMember) return;

        const isMatch = () => {
            const firstName = currentParticipantMember.firstName.toLowerCase();
            const lastName = currentParticipantMember.lastName.toLowerCase();
            if (`${firstName}${lastName}`.includes(conversationSearchQuery)) {
                return true;
            }
            return false;
        };

        if (conversationSearchQuery === '') {
            setIsVisible(true);
            return;
        }

        setIsVisible(isMatch());
    }, [conversationSearchQuery, currentParticipantMember]);

    const handleClick = () => {
        setConversationSearchQuery('');
    };

    const handleKeyDown = e => {
        if (e.keyCode === 13) {
            setConversationSearchQuery('');
        }
    };

    return (
        <div hidden={!isVisible} onClick={handleClick} onKeyDown={handleKeyDown} role="button" tabIndex="0">
            {children}
        </div>
    );
};

InboxConversationItemVisibility.propTypes = {
    conversation: PropTypes.any,
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

export default InboxConversationItemVisibility;
